import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './locales/en/common.json';
import frCommon from './locales/fr/common.json';
import ptCommon from './locales/pt/common.json';

const FALLBACK_LANGUAGE = 'en';
const LANGUAGE_STORAGE_KEY = 'qualiz_language';

const storedLanguage =
  typeof window !== 'undefined' ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY) : null;

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon },
    fr: { common: frCommon },
    pt: { common: ptCommon },
  },
  lng: storedLanguage || FALLBACK_LANGUAGE,
  fallbackLng: FALLBACK_LANGUAGE,
  ns: ['common'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export { i18n as default, LANGUAGE_STORAGE_KEY, FALLBACK_LANGUAGE };
